export default __webpack_public_path__ + "static/media/Upload_Submission.ea4bd134.svg";